/* eslint-disable import/prefer-default-export */
import { History } from 'history';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from 'data/root.reducers';
import { Action } from 'redux';
import { DomainFormItem } from 'routes/Fqdn/hooks/useDomainForm';
import * as actions from './fqdn.api'
import { SYSTEM_CONFIGURATION_ROUTE, NETWORK, FQDN } from '../../constants';
import {
    Domain, GET_FQDNS, ON_SELECT_FQDN, ON_ENTER_FQDN_LIST_PAGE, DELETE_FQDN_FULFILLED, DELETE_FQDN_REJECTED, DELETE_FQDN_PENDING, CREATE_FQDN_REJECTED, CREATE_FQDN_FULFILLED, UPDATE_FQDN_FULFILLED
} from './fqdn.types'

const goToListFqdnPage = (history?: History) => {
    if (history) {
        history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${FQDN}`)
    }
}

export const getFqdn = (deliveryFunction: string) => ({
    type: GET_FQDNS,
    payload: actions.getFqdn(deliveryFunction)
});

export const deleteAllByFsId = (deliveryFunction: string, items: Domain[]) => async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
        dispatch({ type: DELETE_FQDN_PENDING });
        await Promise.all(items.map(({ id }) => actions.deleteFqdn({ deliveryFunction, id })));
        dispatch({ type: DELETE_FQDN_FULFILLED });
        dispatch(getFqdn(deliveryFunction));
    } catch (error) {
        dispatch({ type: DELETE_FQDN_REJECTED, payload: error });
    }
}

export type DomainFormRequestItem = Domain & DomainFormItem;
export const executeOperationOnList = (deliveryFunction: string, items: DomainFormRequestItem[], history: History) => async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
        dispatch({ type: DELETE_FQDN_PENDING });
        await Promise.all(items.map(({ operation, index, ...item }) => {
            const body = {
                // TODO: insert audit data
                data: { ...item }
            }

            switch (operation) {
                case 'CREATE':
                    body.data.fId = (index + 1).toString()
                    return actions.createFqdn({ deliveryFunction, body });
                case 'UPDATE':
                    return actions.updateFqdn({ deliveryFunction, body, id: item.id });
                case 'DELETE':
                    return actions.deleteFqdn({ deliveryFunction, id: item.id })
                default:
                    return null;
            }
        }));

        const isCreateExecution = items.every(({ operation }) => operation === 'CREATE');
        const type = isCreateExecution ? CREATE_FQDN_FULFILLED : UPDATE_FQDN_FULFILLED

        dispatch(onSelectFqdn({ ...items[0] }))
        dispatch({ type });
        goToListFqdnPage(history);
    } catch (error) {
        dispatch({ type: CREATE_FQDN_REJECTED, payload: error });
    }
}

export const onSelectFqdn = (selectedItem: Domain) => ({
    type: ON_SELECT_FQDN,
    payload: selectedItem
});

export const onEnterFqdnlist = () => ({
    type: ON_ENTER_FQDN_LIST_PAGE
});
